







































































































































import {Prop, Vue, Watch} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';
import {BaseComponent} from '@/mixins/BaseComponent';

import {Notify} from '@/utils/Notify';

import {DeviceEthernet} from '@/model/network/device/DeviceEthernet';
import {Profile} from '@/model/network/profile/Profile';
import {DeviceStateColor} from '@/model/network/device/DeviceState';
import {ConnectionStateColor} from '@/model/network/connection/ConnectionState';
import {IpMode} from '@/model/network/IpMode';
import {Connection} from '@/model/network/connection/Connection';

import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';

import NetworkProfilesStore from '@/store/network/NetworkProfiles.store';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';

import NetworkIpStatusDisplay from '@/components/Networking/Connection/NetworkIpStatusDisplay.vue';
import NetworkIpSettingsDisplay from '@/components/Networking/Profile/NetworkIpSettingsDisplay.vue';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';
import NetworkEthernetSettingsEditorModal
  from '@/components/Networking/Ethernet/NetworkEthernetSettingsEditorModal.vue';
import NetworkIpStatusDisplayHeader from '@/components/Networking/Connection/NetworkIpStatusDisplayHeader.vue';
import NetworkIpSettingsDisplayHeader from '@/components/Networking/Profile/NetworkIpSettingsDisplayHeader.vue';
import NetworkConnectionSettingsDisplay from '@/components/Networking/Profile/NetworkConnectionSettingsDisplay.vue';
import NetworkConnectionStatus from '@/components/Networking/Connection/NetworkConnectionStatus.vue';
import NetworkIpSettings from '@/components/Networking/Profile/NetworkIpSettings.vue';

@Component({
  components: {
    NetworkIpSettings,
    NetworkConnectionStatus,
    NetworkEthernetSettingsEditorModal,
    NetworkConnectionSettingsDisplay,
    NetworkIpSettingsDisplayHeader,
    NetworkIpStatusDisplayHeader,
    PropertyDisplayer,
    NetworkIpSettingsDisplay,
    NetworkIpStatusDisplay,
  },
})
export default class NetworkDeviceEthernet extends Mixins<BaseComponent>(BaseComponent) {

  private IpMode = IpMode;
  private DeviceStateColor = DeviceStateColor;
  private ConnectionStateColor = ConnectionStateColor;

  @Inject(Symbol.for('INetworkDeviceService'))
  private deviceService!: INetworkDeviceService;

  private connectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private profilesStore: NetworkProfilesStore = getModule(NetworkProfilesStore, this.$store);

  @Prop(Object)
  private device!: DeviceEthernet;

  private lastDevice: DeviceEthernet | null = null;

  private settingsEditor: boolean = false;

  private ipMode: IpMode = IpMode.IPv4;

  private async mounted() {
    if (this.device) {
      await this.statsRefreshEnable(this.device.Id);
    }
    this.lastDevice = this.device;
  }

  private async beforeDestroy() {
    this.logger.trace('beforeDestroyed');
    if (this.lastDevice) {
      await this.statsRefreshDisable(this.lastDevice.Id);
    }
  }

  private async statsRefreshEnable(deviceId: string) {
    try {
      await this.deviceService.setStatisticsRefreshRate(deviceId, 5);
    } catch (error) {
      Notify.Error(this.logger, `Could not refresh RS/TX statistics, they may be outdated`, error);
    }
  }

  private async statsRefreshDisable(deviceId: string) {
    try {
      await this.deviceService.setStatisticsRefreshRate(deviceId, 0);
    } catch (error) {
    }
  }

  @Watch('device')
  private async onDeviceChanged() {

    if (this.lastDevice && (!this.device || (this.lastDevice.Id !== this.device.Id))) {
      await this.statsRefreshDisable(this.lastDevice.Id);
    }

    if (!this.device) {
      return;
    }

    this.setLoading();

    if (!this.lastDevice || (this.lastDevice.Id !== this.device.Id)) {
      await this.statsRefreshEnable(this.device.Id);
    }

    try {
      await this.connectionsStore.fetchConnection(this.device.ConnectionId);
    } catch (error) {
      Notify.Error(this.logger, `Could not get connection '${this.device.ConnectionId}'`, error);
    }

    try {
      await this.profilesStore.fetchProfile(this.device.ConnectionId);
    } catch (error) {
      Notify.Error(this.logger, `Could not get profile '${this.device.ConnectionId}`, error);
    }

    this.setLoaded();

    this.lastDevice = this.device;
  }

  get connection(): Connection | null {
    return this.connectionsStore.Connections?.find((c) => c.Id === this.device.ConnectionId) ?? null;
  }

  get profile(): Profile | null {
    return this.profilesStore.Profiles?.find((p) => p.Settings.Connection.Id === this.device.ConnectionId) ?? null;
  }
}
